/* eslint-disable */
import { request } from "@umijs/max";

/** 10204-商品新增 新增商品-默认会是下架状态 POST /web/v1/goods/add */
export async function addGoods(
  body: API.SwimGoodsAddVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOLong>("/web/v1/goods/add", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 10211-查询周期卡年龄价格 根据商品ID查询周期卡的年龄价格列表 GET /web/v1/goods/agePrice/${param0} */
export async function getGoodsAgePrice(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getGoodsAgePriceParams,
  options?: { [key: string]: any }
) {
  const { goodsId: param0, ...queryParams } = params;
  return request<any>(`/web/v1/goods/agePrice/${param0}`, {
    method: "GET",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 10210-设置周期卡年龄价格 设置周期卡的年龄价格，支持批量设置和立即上架 POST /web/v1/goods/agePrice/set */
export async function setGoodsAgePrice(
  body: API.SwimGoodsAgePriceSetVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/web/v1/goods/agePrice/set", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 10220-设置套餐卡价格  */
export async function setGoodsComboPrice(
  body: any,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/web/v1/goods/combo/price/set", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 10217-商品基础信息详情 回显基础信息与年龄段ID列表 GET /web/v1/goods/basic/detail/${param0} */
export async function basicDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.basicDetailParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOGoodsBasicDetailResp>(
    `/web/v1/goods/basic/detail/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 10215-商品基础信息保存 请使用10204 仅保存基础信息（参数转换复用旧addGoods） POST /web/v1/goods/basic/save */
export async function basicSave(
  body: API.GoodsBasicSaveReq,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOLong>("/web/v1/goods/basic/save", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 10216-商品基础信息更新 请使用10205 仅更新基础信息（参数转换复用旧updateGoods） POST /web/v1/goods/basic/update */
export async function basicUpdate(
  body: API.GoodsBasicUpdateReq,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/web/v1/goods/basic/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 10214-套餐商品详情查询 根据套餐商品ID查询套餐详情，包含子商品信息 GET /web/v1/goods/combo/detail/${param0} */
export async function getComboGoodsDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getComboGoodsDetailParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOSwimGoodsComboDetailVo>(
    `/web/v1/goods/combo/detail/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 10220-设置套餐卡价格 仅支持套餐卡，直接更新原价与售价 POST /web/v1/goods/combo/price/set */
export async function setComboPrice(
  body: API.ComboPriceSetReq,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/web/v1/goods/combo/price/set", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 10221-查询组合卡可选商品（平铺） 商品类型=2且上架中的商品，按商品×年龄段平铺返回 GET /web/v1/goods/combo/selectable */
export async function listComboSelectableGoods(options?: {
  [key: string]: any;
}) {
  return request<API.YmResultVOListComboSelectableGoodsItemVo>(
    "/web/v1/goods/combo/selectable",
    {
      method: "GET",
      ...(options || {}),
    }
  );
}

/** 10206-商品删除 删除商品 GET /web/v1/goods/delete/${param0} */
export async function deleteGoods(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteGoodsParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOBoolean>(`/web/v1/goods/delete/${param0}`, {
    method: "GET",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 10202-商品详情查询（管理端） 管理端根据商品ID查询商品详情 GET /web/v1/goods/detail/${param0} */
export async function getGoodsDetailById(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getGoodsDetailByIdParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOGoodsBasicDetailResp>(
    `/web/v1/goods/detail/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 10209-获取商品详情内容 根据商品ID和详情类型获取商品详情内容 GET /web/v1/goods/detail/content */
export async function getGoodsDetailContent(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getGoodsDetailContentParams,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOSwimGoodsDetailContentVo>(
    "/web/v1/goods/detail/content",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 10208-编辑商品详情 编辑商品详情内容，已存在则更新，不存在则新增 POST /web/v1/goods/detail/edit */
export async function editGoodsDetail(
  body: API.SwimGoodsDetailEditVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/web/v1/goods/detail/edit", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 10201-商品列表查询 分页查询商品列表 POST /web/v1/goods/list */
export async function getGoodsList(
  body: any,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOYmPageResVOSwimGoodsListVo>(
    "/web/v1/goods/list",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 10219-查看商品其他信息 查看服务内容/购前需知/注意事项/退款政策 GET /web/v1/goods/other/detail/${param0} */
export async function getGoodsOther(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getGoodsOtherParams,
  options?: { [key: string]: any }
) {
  const { goodsId: param0, ...queryParams } = params;
  return request<API.YmResultVOGoodsOtherInfoResp>(
    `/web/v1/goods/other/detail/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 10218-编辑商品其他信息 统一入库服务内容/购前需知/注意事项/退款政策 POST /web/v1/goods/other/edit */
export async function editGoodsOther(
  body: API.GoodsOtherInfoEditReq,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/web/v1/goods/other/edit", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 10222-查询所有商品列表 GET /web/v1/goods/listall */
export async function getGoodsListAll(options?: { [key: string]: any }) {
  return request<any>("/web/v1/goods/listall", {
    method: "GET",
    ...(options || {}),
  });
}

/** 10203-商品价格查询 根据商品ID查询商品价格（日历式显示） GET /web/v1/goods/price/${param0} */
export async function getGoodsPrice(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getGoodsPriceParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOListSwimGoodsPriceCalendarVo>(
    `/web/v1/goods/price/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 10207-批量商品上下架 批量更新商品上下架状态 POST /web/v1/goods/status/batch */
export async function batchUpdateGoodsStatus(
  body: API.SwimGoodsBatchStatusUpdateVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/web/v1/goods/status/batch", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 10205-商品修改 修改商品信息 POST /web/v1/goods/update */
export async function updateGoods(
  body: API.SwimGoodsUpdateVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/web/v1/goods/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
